import { ClientSortSpecBase } from "abweb/dto/generated/ds/ClientSortSpecBase";
export class ClientSortSpec extends ClientSortSpecBase {
  static createClientSortSpec(direction, fieldPath) {
    const retVal = new ClientSortSpec();
    retVal.initClientSortSpec(direction, fieldPath);
    return retVal;
  }
  constructor() {
    super();
  }
  isEqual(other) {
    return this.direction === other.direction && this.fieldPath === other.fieldPath;
  }
}
//# sourceMappingURL=ClientSortSpec.js.map
